import { render, staticRenderFns } from "./StatsDashboardForm.vue?vue&type=template&id=8ed7af7c&"
import script from "./StatsDashboardForm.vue?vue&type=script&lang=js&"
export * from "./StatsDashboardForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports